export const CURRENCY = "AED";

export const USER_ORIGIN_SOURCE = { WEB: "web", WEB_MOBILE: "web-Mobile" };
